function closeRosterModal(){
  document.getElementById('rosterModal').style.display = "none";
}
function addanotherrosterrow(){
  var $row = $('#roster_content').children('tr:first').html();
  //console.log($row);
  var table = document.getElementById("tth-custom-table");
  var row = table.insertRow();
  row.classList.add('subrost');
  row.innerHTML = $row;
  //console.log("row1");
  if(row.querySelector('input[name="ptext[]"]') != undefined){
    row.querySelector('input[name="ptext[]"]').readOnly = true;
  }
  if(row.querySelector('select[name="product_varients[]"]') != undefined){
    row.querySelector('select[name="product_varients[]"]').selectedIndex = 0;
  }
  if(row.querySelector('input[name="product_qty[]"]') != undefined){
    row.querySelector('input[name="product_qty[]"]').value = 1;
  }
  //console.log("row2", ele);
  row.getElementsByClassName("delete-curr-row")[0].innerHTML = `<button class="btn btn-trans" onclick="deleteRosterRow(this)" style="cursor: pointer;background: none;height: 10px !important;"><?xml version="1.0" encoding="utf-8"?><svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="16px" height="16px" viewBox="0 0 24 24"><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"/></svg></button>`;
}
function RealInitRoster() {
  $('#roster_content').find("tr:not(:first)").remove();
}
function deleteRosterRow(e){
  $(e).parents('tr').remove();
  // $(e).closest('tr').remove();
}

function enablePText(e) {
  var textfield = $(e).parents('tr').find('input[name="ptext[]"]');
  if ($(e).is(':checked')){
    textfield.attr("readonly", false);
  } else {
    textfield.val('');
   textfield.attr("readonly", true);
  }
}